function getSlideRequest (data, title, subtitle, settings) {
    let chartSlide = { SlideType: 'info-slide', ChartRequests: [] };
    let slideTitle = 'Conversability - ' + data.projectName;
    chartSlide.Title = title || slideTitle;
    let slideSubtitle = `${data.projectStartDate} - ${data.projectEndDate} (by ${data.projectPeriod})`;
    chartSlide.Subtitle = subtitle || slideSubtitle;
    chartSlide.infoSlideData = data;

    return chartSlide;
}

class InfoSlideRequestor {
    getSlideRequest (data, title, subtitle, settings) {
        return getSlideRequest(data, title, subtitle, settings);
    }
}

export const infoSlideRequestor = new InfoSlideRequestor();
